<template>
  <div>
    <el-form ref="formRef" :model="userForm" label-width="140px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="userForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="userForm" showList="name,phone,uid,city,birth" :isDialog="true"/>
        </div>
      </el-form-item>
      <el-form-item label="状态：">
        <div class="item-info">
          <p>信息审核：{{userForm.resumeState == 0 ? "未查看" : userForm.resumeState == 1 ? "待审核" : userForm.resumeState == 2 ? "已通过" : userForm.resumeState == 3 ? "不通过" : "--"}}</p>
          <p>身份证认证：{{userForm.identityAuth.overallAuthState == 0 ? "未提交" : userForm.identityAuth.overallAuthState == 1 ? "待审核" : userForm.identityAuth.overallAuthState == 2 ? "审核通过" : userForm.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
          <p>微信审核：{{userForm.wechatState == 0 ? '未提交' : userForm.wechatState == 1 ? '待审核' : userForm.wechatState == 2 ? '已通过' : userForm.wechatState == 3 ? '不通过' : '--'}}</p>
          <p>是否是vip：<span style="color: #3a8ee6">{{userForm.vipState == 0 ? '否' : userForm.vipState == 1 ? '是' : userForm.vipState == 2 ? '是' : '--'}}</span></p>
        </div>
      </el-form-item>
      <el-form-item label="vip剩余时间：">
        <span v-if="userForm.vipState == 2">终身VIP</span>
        <span v-if="userForm.vipExpireDay">{{ userForm.vipExpireDay }}天</span>
      </el-form-item>
      <el-form-item label="操作：">
        <el-select v-model="type" placeholder="请选择"  style="width: 14em;">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="天数：" v-if="type == 1">
        <el-input type="text" placeholder="请输入天数" v-model="num" style="width:14em"  />
        <p style="color: #f00;font-size:12px;">*允许输入负数，负数则代表扣除对应的天数</p>
      </el-form-item>
      <el-form-item>
        <div class="dialog-footer">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { postFormData } from "@/api/api";
import { updateVipUserExpire } from "@/api/url";
import { intReg } from "@/assets/shared/reg-constant";

export default {
  name: "VipUserSearchInfoDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      idx: this.value.idx,
      loading: false,
      num: '',
      typeArray: this.value.userForm.vipState == 2?[
        {label: '解除服务', value: 0},
      ]:[
        {label: '自定义', value: 1},
        {label: '赠送终身vip', value: 2},
        {label: '解除服务', value: 0},
      ],
      type: this.value.userForm.vipState == 2?0:1,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      if(this.type == 1) {
        this.typeOne()
      } else {
        this.updateExpire(this.userForm, this.type)
      }
    },

    typeOne() {
      if(!this.num && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '天数不能为空',
          type: 'warning'
        });
        return;
      }
      if(!intReg.test(this.num) && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '天数请输入整数',
          type: 'warning'
        });
        return;
      }
      this.loading = true
      let param = {}
      param['id'] = this.userForm.userId
      param['type'] = this.type
      param['day'] = this.type == 1?this.num:0,
      postFormData(updateVipUserExpire, param).then((data) => {
        let {code, msg} = data
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    //隐藏
    updateExpire(row, type) {
      this.$confirm('确定给昵称为【' + row.nickName + '】的用户' + (type == 2?'赠送终身VIP？':'解除VIP服务？')).then(()=>{
        this.loading = true
        let _this = this;
        let param = {};
        param['id'] = row.userId;
        param['type'] = type;
        param['day'] = 0;
        postFormData(updateVipUserExpire, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.loading = false
        })
            .catch(()=>{
              this.loading = false
            })
      })
    },


  },
  created() {

  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
